/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InternalSceneCameraDTO } from '../models/InternalSceneCameraDTO';
import type { InternalSceneCameraDTOODataListResponse } from '../models/InternalSceneCameraDTOODataListResponse';
import type { SceneCamera } from '../models/SceneCamera';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InternalSceneCameraService {

    /**
     * @param top The max number of records.
     * @param skip The number of records to skip.
     * @param filter A function that must evaluate to true for a record to be returned.
     * @param select Specifies a subset of properties to return. Use a comma separated list.
     * @param orderby Determines what values are used to order a collection of records.
     * @param expand Use to add related query data.
     * @param count Include the overall count
     * @returns InternalSceneCameraDTOODataListResponse Success
     * @throws ApiError
     */
    public static getInternalSceneCamera(
top?: string,
skip?: string,
filter?: string,
select?: string,
orderby?: string,
expand?: string,
count?: string,
): CancelablePromise<InternalSceneCameraDTOODataListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/SceneCamera',
            query: {
                '$top': top,
                '$skip': skip,
                '$filter': filter,
                '$select': select,
                '$orderby': orderby,
                '$expand': expand,
                '$count': count,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns InternalSceneCameraDTO Success
     * @throws ApiError
     */
    public static postInternalSceneCamera(
requestBody?: InternalSceneCameraDTO,
): CancelablePromise<InternalSceneCameraDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/internal/SceneCamera',
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns InternalSceneCameraDTO Success
     * @throws ApiError
     */
    public static getInternalSceneCamera1(
key: number,
): CancelablePromise<InternalSceneCameraDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/SceneCamera/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param key 
     * @param requestBody 
     * @returns InternalSceneCameraDTO Success
     * @throws ApiError
     */
    public static putInternalSceneCamera(
key: number,
requestBody?: InternalSceneCameraDTO,
): CancelablePromise<InternalSceneCameraDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/internal/SceneCamera/{key}',
            path: {
                'key': key,
            },
            body: requestBody,
            mediaType: 'application/json;odata.metadata=minimal;odata.streaming=true',
        });
    }

    /**
     * @param key 
     * @returns any Success
     * @throws ApiError
     */
    public static deleteInternalSceneCamera(
key: number,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/internal/SceneCamera/{key}',
            path: {
                'key': key,
            },
        });
    }

    /**
     * @param clientId 
     * @param query 
     * @returns SceneCamera Success
     * @throws ApiError
     */
    public static getInternalSceneCameraQuery(
clientId?: number,
query?: string,
): CancelablePromise<Array<SceneCamera>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal/SceneCamera/query',
            query: {
                'clientId': clientId,
                'query': query,
            },
        });
    }

}
